import { combineReducers } from "redux";
import bet_history from "../features/admin/roulette/bet_history/slice";

const roulette = combineReducers({
  bet_history: bet_history,
});

export default roulette;
